'use strict';
import React, { Component } from 'react';
var FormatMessage = require('react-globalize').FormatMessage;


let monthNames_en = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];
let monthNames_es = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

export default class FraudAlerts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idTransaction : "",
      month : -1,
      day : -1,
      year : -1,
      nameCustomer : "",
      lastNameCustomer : "",
      phoneNumberCustomer : "",
      descriptionCustomer : "",
      isContacted : props.locale == "es" ? "Si" : "Yes",
      errors: {},
      disableSubmit : false,
      textSubmitButton : props.locale == "es" ? "Finalizar" : "Finalize"
    }
    this.setDays = this.setDays.bind(this);
    this.setMonths = this.setMonths.bind(this);
    this.changeMonth = this.changeMonth.bind(this);
    this.setYears = this.setYears.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.verifyData = this.verifyData.bind(this);
    this.resetFields = this.resetFields.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
  }

  componentDidMount () {
    this.setMonths();
    this.setYears();
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (this.props.locale !== prevProps.locale) {
      this.setMonths();
      this.setYears();
    }
  }

  setMonths () {
    let months = 12;
    let select = document.getElementById('monthSelect');
    let html = '';
    html +=  this.props.locale === "es" ? '<option value="-1">' + "Seleccione uno" + '</option>' :
    '<option value="-1">' + "Select option" + '</option>';

    for (let i = 0; i < months; i++) {
      html += this.props.locale === "es" ? 
        '<option value="' + monthNames_es[i] + '">' + monthNames_es[i] + '</option>' :
        '<option value="' + monthNames_en[i] + '">' + monthNames_en[i] + '</option>'
    }
    select.innerHTML = html;
  }

  changeMonth (event){
    let monthSelected = event.target.value;
    this.setDays(monthSelected);
    this.setState({
      month : monthSelected, 
      day : -1
    })
  }

  setYears () {
    let date = new Date();
    let actualYear = date.getFullYear();
    let select = document.getElementById('yearSelect');
    let html = '';
    html +=  this.props.locale === "es" ? '<option value="-1">' + "Seleccione uno" + '</option>' :
    '<option value="-1">' + "Select option" + '</option>';
    html += '<option value="'+ actualYear +'">' + actualYear + '</option>'
    for (let i = 0; i < 10; i++) {
      let year = actualYear - 1;
      html += '<option value="' + year + '">' + year + '</option>';
      actualYear = year; 
    }
    select.innerHTML = html;
  }

  setDays (month) {
    let select = document.getElementById('daySelect');
    select.innerHTML = "";
    var monthArray = this.props.locale == "es" ? monthNames_es : monthNames_en;
    let value = month;
    let numOfDays;
    let html = '';
    html +=  this.props.locale === "es" ? '<option value="-1">' + "Seleccione uno" + '</option>' :
    '<option value="-1">' + "Select option" + '</option>';
    if (value === monthArray[3] || value === monthArray[5] || value === monthArray[8] || value === monthArray[10]) {
      numOfDays = 30;
    } else if (value === monthArray[0] || value === monthArray[2] || value === monthArray[4] 
        || value === monthArray[6] || value === monthArray[7] || value === monthArray[9] || value === monthArray[11]) {
      numOfDays = 31;
    } else {
      numOfDays = 28;
    }

    for (var i = 1; i <= numOfDays; i++) {
      if (i < 10) {
        i = "0" + i;
      }
      html += '<option value="' + i + '">' + i + '</option>'
    } 
    select.innerHTML = html;
  }

  verifyData () {
    let isValid = true;
    let errors = {};

    if (!this.state.idTransaction || this.state.idTransaction == "") {
      isValid = false;
      errors["idTransaction"] = <FormatMessage locale={this.props.locale} path="fraudAware/cannotNull" />;
    }

    if (!this.state.month || this.state.month == -1) {
      isValid = false;
      errors["monthSelect"] = <FormatMessage locale={this.props.locale} path="fraudAware/cannotNull" />;
    }

    if (!this.state.day || this.state.day == -1) {
      isValid = false;
      errors["daySelect"] = <FormatMessage locale={this.props.locale} path="fraudAware/cannotNull" />;
    }

    if (!this.state.year || this.state.year == -1) {
      isValid = false;
      errors["yearSelect"] = <FormatMessage locale={this.props.locale} path="fraudAware/cannotNull" />;
    }

    if (!this.state.nameCustomer || this.state.nameCustomer == "") {
      isValid = false;
      errors["nameCustomer"] = <FormatMessage locale={this.props.locale} path="fraudAware/cannotNull" />;
    }

    if (!this.state.lastNameCustomer || this.state.lastNameCustomer == "") {
      isValid = false;
      errors["lastNameCustomer"] = <FormatMessage locale={this.props.locale} path="fraudAware/cannotNull" />;
    }

    if (!this.state.phoneNumberCustomer || this.state.phoneNumberCustomer == "") {
      isValid = false;
      errors["phoneNumberCustomer"] = <FormatMessage locale={this.props.locale} path="fraudAware/cannotNull" />;
    }

    if (!this.state.isContacted) {
      isValid = false;
      errors["isContacted"] = <FormatMessage locale={this.props.locale} path="fraudAware/cannotNull" />;
    }

    if (!this.state.descriptionCustomer || this.state.descriptionCustomer == "") {
      isValid = false;
      errors["descriptionCustomer"] = <FormatMessage locale={this.props.locale} path="fraudAware/cannotNull" />;
    }

    if (isValid) {
      this.setState({disableSubmit : true, textSubmitButton : this.props.locale == "es" ? "Cargando":"Loading"})
    }

    this.setState({errors: errors});
    return isValid;
  }

  resetFields () {
    this.setState({
      idTransaction : "",
      month : -1,
      day : -1,
      year : -1,
      nameCustomer : "",
      lastNameCustomer : "",
      phoneNumberCustomer : "",
      isContacted : this.props.locale == "es" ? "Si" : "Yes",
      descriptionCustomer : "",
      errors: {},
      disableSubmit : false,
      textSubmitButton : this.props.locale == "es" ? "Finalizar" : "Finalize"
    });
    let select = document.getElementById('daySelect');
    let html = '';
    html +=  this.props.locale === "es" ? '<option value="-1">' + "Seleccione uno" + '</option>' :
    '<option value="-1">' + "Select option" + '</option>';
    select.innerHTML = html;
  }

  handleSubmit(event) {
    let dataToSend = this.state;
    dataToSend.lang = this.props.locale;
    event.preventDefault();
    if (this.verifyData()) {
      $.ajax({
        url: '/api/sendFormFraud',
        method : 'POST',
        cache: false,
        data : dataToSend,
        success: function(data) {
          let dataToShow = this.props.locale == "es" ? "Su solicitud ha sido enviada con éxito." : "Your request has been successfull";
          this.resetFields();
          alert(dataToShow);
        }.bind(this),
        error: function(xhr, status, err) {
          let dataToShow = this.props.locale == "es" ? "Hubo un error al enviar su solicitud. \nContacte a soporte técnico" :
           "There was an error submitting your request. Contact technical support";
           this.setState({disableSubmit : false, textSubmitButton : this.props.locale == "es" ? "Finalizar" : "Finalize"})
          alert(dataToShow);
        }.bind(this)
      });
    }
  }

  onChangeValue(event) {
    this.setState({
      isContacted: event.target.value
    });
  }

  render () {
    return (
      <div className="container">
        <div className="row text-justify">
          {
            this.props.locale == "es" ?
            <div className="col-md-12" style={{padding:35}}>
              <div className="row">
                <p>
                  Cuanto más sepa, más seguro estará y menos probabilidades de 
                  ser víctima de un fraude. Aquí están nuestras preguntas más 
                  frecuentes relacionadas con el fraude. 
                </p>
                <p style={{fontWeight:"bold"}}>
                  ¿Qué hago si me han estafado?
                </p>
                <p>
                  <ul>
                    <li>Póngase en contacto con su policía local de inmediato.</li>
                    <li>Reporte sospechas de incidentes de fraude telefónico o de Internet enviando 
                      un informe en línea al Centro de Fraude de la Liga Nacional de Consumidores.</li>
                    <li>Presente una queja ante la Comisión Federal de Comercio o llame al número 
                      gratuito 1-877-FTC-HELP</li>
                    <li>Presente una queja ante su Fiscal General.</li>
                    <li>Si utilizó Barri para transferir dinero como resultado de una estafa, 
                      comuníquese con Barri al 1-888-488-3201.</li>
                  </ul>
                </p>
                <p style={{fontWeight:"bold"}}>
                  ¿Qué hago si me han estafado en línea?
                </p>
                <p>
                  <ul>
                    <li>Si fue víctima de fraude a través de Internet, presente un informe a la 
                      policía local y al Centro de Quejas de Delitos en Internet (CCCC), una 
                      asociación entre el FBI y el Centro Nacional de Delitos de Cuello Blanco.</li>
                    <li>Si usó a Barri para enviar dinero como resultado de una estafa, 
                      llame a Barri al 1-888-488-3201.</li>
                    
                  </ul>
                </p>
                <p style={{fontWeight:"bold"}}>
                  ¿Cómo engañan los estafadores a la gente?
                </p>
                <p>
                  <ul>
                    <li>Los defraudadores se aprovechan de su confianza en las personas.</li>                    
                  </ul>
                </p>
                <p style={{fontWeight:"bold"}}>
                  ¿Cuáles son las señales de advertencia de fraude de transferencia de dinero?
                </p>
                <p>
                  <ul>
                    <li>Alguien que no conoces te pide que envíes dinero.</li>
                    <li>Alguien le pide que deposite un cheque y le devuelva una parte del dinero.</li> 
                    <li>Alguien se hace pasar por un amigo o familiar y llama en una crisis, 
                      pidiéndole que envíe dinero de inmediato.</li>                    
                    <li>Alguien le dice que ganó un premio o concurso en el que no recuerda 
                      haber ingresado y le pide que transfiera dinero para pagar tarifas, 
                      impuestos o aduanas.</li> 
                  </ul>
                </p>
                <p style={{fontWeight:"bold"}}>
                  ¿Quién está en mayor riesgo de fraude de transferencia bancaria?
                </p>
                <p>
                  Todos están en riesgo. Los estafadores se dirigen a todos. Buscan 
                  personas que parecen ser vulnerables, no conocen una estafa y confían 
                  en los demás.
                </p>
                <p style={{fontWeight:"bold"}}>
                  ¿Existen riesgos para las transferencias bancarias de dinero?
                </p>
                <p>
                  Sí, cuando no sabes a quién le envías el dinero. Enviar dinero es lo mismo 
                  que enviar dinero en efectivo. Una vez que lo envías, desaparece y no puedes 
                  recuperarlo.
                </p>
                <p style={{fontWeight:"bold"}}>
                  ¿Es seguro enviar dinero?
                </p>
                <p>
                  Sí, sí sabe a quién le está enviando el dinero. La transferencia de dinero 
                  es una forma segura, rápida y conveniente de llevar dinero en efectivo a 
                  amigos y familiares.
                </p>
                <p style={{fontWeight:"bold"}}>
                  ¿Qué es el fraude de transferencia de dinero o el fraude de transferencia bancaria?
                </p>
                <p>
                  El fraude de transferencia de dinero o el fraude de transferencia de 
                  envío ocurren cuando los estafadores convencen a los consumidores 
                  para que les envíen dinero.
                </p>
                <p style={{fontWeight:"bold"}}>
                  ¿Cómo denuncio esta estafa a la Comisión Federal de Comercio ya mi Fiscal General del Estado?
                </p>
                <p>
                  Además de denunciar una estafa a Barri, también puede informarla a la 
                  <a href="https://www.ftccomplaintassistant.gov/#crnt&panel1-1" target="_blank"> FTC</a> o al 
                  <a href="https://www.naag.org/naag/attorneys-general/whos-my-ag.php" target="_blank"> Fiscal General de su estado.</a>
                </p>

                <div style={{margin:"35px 0px"}}>
                  <hr className="small-blue" />
                  <p style={{fontWeight:"bold", textAlign: "center", fontSize:20}}>Reportar las estafas/ fraude</p>
                  <p>
                    En un estudio, mostro que solo alrededor de un 14% estimado de las víctimas reportaron 
                    la estafas y/o fraudes, ya sea por vergüenza, por pensar que era inútil o simplemente, 
                    que no sabían a quién podían reportarlo. Pero informar es importante porque determina 
                    estadísticas precisas sobre la cantidad de personas afectadas y porque el FBI y otras 
                    agencias de seguridad destinan recursos considerables a romper los círculos fraudulentos. 
                  </p>
                  <p>
                    Si cree que puede haber sido víctima de un fraude y su transferencia no ha sido pagada, 
                    llame de inmediato a la línea directa de Barri 1-888-488-3201 lo antes posible para 
                    obtener ayuda y/o para presentar una queja por fraude.
                  </p>
                  <p>
                    Tambien puede llenar el siguiente formulario, para reportar si fue victima de fraude.
                  </p>
                  <p style={{color:"red", fontWeight:"bold", textAlign: "left"}}>
                    Presentar una reclamación por fraude:
                  </p>
                  <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                      <label for="exampleInputEmail1">1.- Número de transaccion: </label>
                      <input onChange={(value) => { this.setState({idTransaction : value.target.value}) }} value={this.state.idTransaction} 
                        type="number" className="form-control" id="idTransaction" placeholder="Número de la transacción"/>
                      <span style={{color: "red"}}>{this.state.errors["idTransaction"]}</span>
                      <div className="col-md-12" style={{textAlign:"center", marginBottom:20}}>
                        <img className="img-responsive" style={{height: 150,width: "60%", margin:'auto'}} src="img/numberTransaction_1.jpg" alt="alert" />
                      </div>
                      <p style={{textAlign:"center"}}>
                        Confirme que el número de transacción que ingresó arriba coincide 
                        con el número que se muestra en su recibo.
                      </p>
                    </div>

                    <label>2.- Fecha de la transacción: </label>
                    <div className="form-row">
                      <div className="form-group col-md-4">
                        <label for="monthSelect">Mes</label>
                        <select value={this.state.month} onChange={this.changeMonth} className="form-control" id="monthSelect" placeholder="Mes">
                        </select>
                        <span style={{color: "red"}}>{this.state.errors["monthSelect"]}</span>
                      </div>
                      <div className="form-group col-md-4">
                        <label for="daySelect">Día</label>
                        <select value={this.state.day} onChange={(value) => { this.setState({ day : value.target.value }) }} className="form-control" id="daySelect" placeholder="Día">
                          <option value="-1">{this.props.locale == "es" ? "Seleccione uno" : "Select option"}</option>
                        </select>
                        <span style={{color: "red"}}>{this.state.errors["daySelect"]}</span>
                      </div>
                      <div className="form-group col-md-4">
                        <label for="yearSelect">Año</label>
                        <select value={this.state.year} onChange={(value) => { this.setState({year : value.target.value}) }} className="form-control" id="yearSelect" placeholder="Año">
                        </select>
                        <span style={{color: "red"}}>{this.state.errors["yearSelect"]}</span>
                      </div>
                    </div>

                    
                    <div className="form-group">
                      <label>3.- Reporte información necesaria: </label>
                      <label for="exampleInputPassword1">Primer y segundo nombre del cliente: </label>
                      <input type="text" className="form-control" id="nameCustomer"  value={this.state.nameCustomer}
                        onChange={(value) => { this.setState({ nameCustomer : value.target.value }) }} placeholder="Nombre del cliente"/>
                      <span style={{color: "red"}}>{this.state.errors["nameCustomer"]}</span>
                    </div>
                    <div className="form-group">
                      <label for="exampleInputPassword1">Primer y segundo apellido del cliente: </label>
                      <input type="text" className="form-control" id="lastNameCustomer" value={this.state.lastNameCustomer}
                        onChange={(value) => { this.setState({ lastNameCustomer : value.target.value }) }} placeholder="Apellidos del cliente"/>
                      <span style={{color: "red"}}>{this.state.errors["lastNameCustomer"]}</span>
                    </div>
                    <div className="form-group">
                      <label for="exampleInputPassword1">Número de teléfono del cliente: </label>
                      <input type="text" className="form-control" id="phoneNumberCustomer" maxLength={10} value={this.state.phoneNumberCustomer}
                        onChange={(value) => { this.setState({ phoneNumberCustomer : value.target.value }) }} placeholder="Número de teléfono"/>
                      <span style={{color: "red"}}>{this.state.errors["phoneNumberCustomer"]}</span>
                    </div>

                    <label>*Desea ser contactado al numero de telefono informado? (haga click en la opción)</label>
                    <div className="form-group">
                      <div className="form-check">
                        <input type="radio" name="gridRadios" value="Si" checked={this.state.isContacted === "Si"} onChange={this.onChangeValue} /> Si
                        <input style={{marginLeft:10}} type="radio" name="gridRadios" value="No" checked={this.state.isContacted === "No"} onChange={this.onChangeValue}/> No
                      </div>
                      <span style={{color: "red"}}>{this.state.errors["isContacted"]}</span>
                    </div>

                    <label>4.- Por favor, describa lo que pasó: </label>
                    <div className="form-group">
                      <textarea style={{resize:'none'}} onChange={(value) => { this.setState({ descriptionCustomer : value.target.value}) }} 
                        className="form-control" id="descriptionCustomer" rows="5" value={this.state.descriptionCustomer} ></textarea>
                      <span style={{color: "red"}}>{this.state.errors["descriptionCustomer"]}</span>
                    </div>
                    
                    <label style={{marginRight:15}}>Gracias por reportar (HAGA CLIC en finalizar)</label>
                    <button type="submit" className="btn btn-primary" disabled={this.state.disableSubmit}>{this.state.textSubmitButton}</button>
                  </form>
                </div>

                <p style={{color:"red", fontWeight:"bold", marginTop:25}}>
                  Protección contra el fraude al consumidor.
                </p>
                <p>
                  Existen varias organizaciones que brindan información para ayudarlo a 
                  protegerse contra el fraude. Seleccione de las organizaciones a 
                  continuación para obtener más información.
                </p>
                <p>
                  Organizaciones de Estados Unidos
                  <ul>
                    <li><a href="http://www.scamawareness.org/" target="_blank">ScamAwareness.org</a></li>
                    <li><a href="http://www.ftc.gov/" target="_blank">Federal Trade Commission</a></li>
                    <li><a href="http://www.fraud.org/" target="_blank">National Consumers League's Fraud Center</a></li>
                    <li><a href="https://postalinspectors.uspis.gov/" target="_blank">U.S. Postal Inspection Service</a></li>
                    <li><a href="http://www.stopfraud.gov/about.html" target="_blank">StopFraud.gov</a></li>
                    <li><a href="http://www.consumerfinance.gov/" target="_blank">Consumer Financial Protection Bureau</a></li>
                  </ul>
                </p>
              </div>
            </div> 
            
            :

            <div className="col-md-12" style={{padding:35}}>
              <div className="row">
                <p>
                  The more you know, the safer you'll be and less likely 
                  to become a victim of fraud. Here are our most frequently 
                  asked fraud-related questions.  
                </p>
                <p style={{fontWeight:"bold"}}>
                  What do I do if I've been scammed?
                </p>
                <p>
                  <ul>
                    <li>Contact your local police immediately.</li>
                    <li>Report suspected incidents of over-the-phone fraud or Internet 
                      fraud by submitting a report online to the National Consumers 
                      League's Fraud Center.</li>
                    <li>File a complaint with the Federal Trade Commission or call toll 
                      free 1-877-FTC-HELP</li>
                    <li>File a complaint with your Attorney General.</li>
                    <li>If you used Barri to wire money as a result of a scam, contact 
                        Barri at 1-888-488-3201</li>
                  </ul>
                </p>
                <p style={{fontWeight:"bold"}}>
                  What do I do if I've been scammed online?
                </p>
                <p>
                  <ul>
                    <li>If you were a victim of fraud via the Internet, file a report with 
                      your local police and the Internet Crime Complaint Center (CCCC), 
                      a partnership between the FBI and the National White Collar 
                      Crime Center.</li>
                    <li>If you used Barri to wire money as a result of a scam, contact 
                      Barri at 1-888-488-3201</li>
                    
                  </ul>
                </p>
                <p style={{fontWeight:"bold"}}>
                  How do fraudsters fool people?
                </p>
                <p>
                  <ul>
                    <li>Fraudsters take advantage of your trust in people.</li>                    
                  </ul>
                </p>

                <p style={{fontWeight:"bold"}}>
                  What are warning signs of money transfer fraud?
                </p>
                <p>
                  <ul>
                    <li>Someone you don’t know asks you to send money.</li>
                    <li>Someone asks you to deposit a check and send them back a portion 
                      of the money</li> 
                    <li>Someone pretends to be a friend or relative and calls in a crisis, 
                      asking you to send money right away.</li>                    
                    <li>Someone tells you you've won a prize or contest that you don't 
                      remember entering, and asks you to wire money to pay fees, taxes 
                      or customs.</li> 
                  </ul>
                </p>
                <p style={{fontWeight:"bold"}}>
                  Who is most at risk for wire transfer fraud?
                </p>
                <p>
                  Everyone is at risk. Fraudsters target everyone. They look for 
                  people who appear to be vulnerable, don't know about a scam and 
                  are trusting of others.
                </p>
                <p style={{fontWeight:"bold"}}>
                  Are there risks to money wire transfers?
                </p>
                <p>
                  Yes, when you don't know whom you are sending the money to. Sending 
                  money is the same as sending cash. Once you send it, it's gone, 
                  and you can't get it back.
                </p>
                <p style={{fontWeight:"bold"}}>
                  Is it safe to send money?
                </p>
                <p>
                  Yes, if you know to whom you are sending the money. Money transfer 
                  is a safe, fast, convenient way to get cash to friends and family.
                </p>
                <p style={{fontWeight:"bold"}}>
                  What is money transfer fraud or wire transfer fraud?
                </p>
                <p>
                  Money transfer fraud or send transfer fraud both occur when scammers 
                  convince consumers to send them money.
                </p>
                <p style={{fontWeight:"bold"}}>
                  How do I report this scam to the Federal Trade Commission and my State Attorney General?
                </p>
                <p>
                  In addition to reporting a scam to Barri you may also report it to the  
                  <a href="https://www.ftccomplaintassistant.gov/#crnt&panel1-1" target="_blank"> FTC</a> or your state's 
                  <a href="https://www.naag.org/naag/attorneys-general/whos-my-ag.php" target="_blank"> Attorney General.</a>
                </p>

                <div style={{margin:"35px 0px"}}>
                  <hr className="small-blue" />
                  <p style={{fontWeight:"bold", textAlign: "center", fontSize:20}}>Reporting scams/fraud</p>
                  <p>
                    A study showed that only about an estimated 14% of victims reported scams and/or fraud, 
                    either out of shame, for thinking it was useless or simply, that they did not know who 
                    they could report it to. But reporting is important because it determines accurate 
                    statistics on the number of people affected and because the FBI and other security 
                    agencies allocate considerable resources to break down fraudulent circles. 
                  </p>
                  <p>
                    If you believe you may have been the victim of fraud and your transfer has not been 
                    paid for, call the Barri hotline immediately at 1-888-488-3201 as soon as possible 
                    for help and/or to file a fraud complaint.
                  </p>
                  <p>
                    You can also fill out the form below to report if you were a victim of fraud.
                  </p>
                  <p style={{color:"red", fontWeight:"bold", textAlign: "left"}}>
                    File a fraud claim: 
                  </p>
                  <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                      <label for="exampleInputEmail1">1.- Transaction number: </label>
                      <input onChange={(value) => { this.setState({idTransaction : value.target.value}) }} value={this.state.idTransaction}
                        type="number" className="form-control" id="idTransaction" placeholder="Transaction number"/>
                      <span style={{color: "red"}}>{this.state.errors["idTransaction"]}</span>
                      <div className="col-md-12" style={{textAlign:"center", marginBottom:20}}>
                        <img className="img-responsive" style={{height: 150,width: "60%", margin:'auto'}} src="img/numberTransaction_1.jpg" alt="alert" />
                      </div>
                      <p style={{textAlign:"center"}}>
                        Confirm that the transaction number you entered above matches the number shown on your receipt.
                      </p>
                    </div>

                    <label>2.- Transaction day: </label>
                    <div className="form-row">
                      <div className="form-group col-md-4">
                        <label for="monthSelect">Month</label>
                        <select value={this.state.month} onChange={this.changeMonth} className="form-control" id="monthSelect" placeholder="Month">
                        </select>
                        <span style={{color: "red"}}>{this.state.errors["monthSelect"]}</span>
                      </div>
                      <div className="form-group col-md-4">
                        <label for="daySelect">Day</label>
                        <select value={this.state.day} onChange={(value) => { this.setState({ day : value.target.value }) }} className="form-control" id="daySelect" placeholder="Day">
                          <option value="-1">{this.props.locale == "es" ? "Seleccione uno" : "Select option"}</option>
                        </select>
                        <span style={{color: "red"}}>{this.state.errors["daySelect"]}</span>
                      </div>
                      <div className="form-group col-md-4">
                        <label for="yearSelect">Year</label>
                        <select value={this.state.year} onChange={(value) => { this.setState({year : value.target.value}) }} className="form-control" id="yearSelect" placeholder="Year">
                        </select>
                        <span style={{color: "red"}}>{this.state.errors["yearSelect"]}</span>
                      </div>
                    </div>

                    
                    <div className="form-group">
                      <label>3.- Report necessary information: </label>
                      <label for="nameCustomer">Customer first name: </label>
                      <input type="text" className="form-control" id="nameCustomer" value={this.state.nameCustomer}
                        onChange={(value) => { this.setState({ nameCustomer : value.target.value }) }} placeholder="Customer first name"/>
                      <span style={{color: "red"}}>{this.state.errors["nameCustomer"]}</span>
                    </div>
                    <div className="form-group">
                      <label for="lastNameCustomer">Customer last name: </label>
                      <input type="text" className="form-control" id="lastNameCustomer" value={this.state.lastNameCustomer}
                        onChange={(value) => { this.setState({ lastNameCustomer : value.target.value }) }} placeholder="Customer last name"/>
                      <span style={{color: "red"}}>{this.state.errors["lastNameCustomer"]}</span>
                    </div>
                    <div className="form-group">
                      <label for="phoneNumberCustomer">Customer phone number: </label>
                      <input type="text" className="form-control" id="phoneNumberCustomer" maxLength={10} value={this.state.phoneNumberCustomer}
                        onChange={(value) => { this.setState({ phoneNumberCustomer : value.target.value }) }} placeholder="Customer phone number"/>
                      <span style={{color: "red"}}>{this.state.errors["phoneNumberCustomer"]}</span>
                    </div>

                    <label>*Do you want to be contacted at the telephone number provided? (click on the option)</label>
                    <div className="form-group">
                      <div className="form-check">
                        <input type="radio" name="gridRadios" value="Yes" checked={this.state.isContacted === "Yes"} onChange={this.onChangeValue} /> Yes
                        <input style={{marginLeft:10}} type="radio" name="gridRadios" value="No" checked={this.state.isContacted === "No"} onChange={this.onChangeValue}/> No
                      </div>
                      <span style={{color: "red"}}>{this.state.errors["isContacted"]}</span>
                    </div>

                    <label>4.- Please write what happend: </label>
                    <div className="form-group">
                      <textarea style={{resize:'none'}} onChange={(value) => { this.setState({ descriptionCustomer : value.target.value}) }} 
                        className="form-control" id="descriptionCustomer" rows="5" value={this.state.descriptionCustomer}></textarea>
                      <span style={{color: "red"}}>{this.state.errors["descriptionCustomer"]}</span>
                    </div>
                    
                    <label style={{marginRight:15}}>Thanks for reporting (CLICK to finish). FINALIZE)</label>
                    <button type="submit" className="btn btn-primary" disabled={this.state.disableSubmit}>{this.state.textSubmitButton}</button>
                  </form>
                </div>



                <p style={{color:"red", fontWeight:"bold", marginTop:25}}>
                  Protecting against consumer fraud
                </p>
                <p>
                  There are several organizations that provide information to help 
                  protect you from fraud. Select from the organizations below to learn more.
                </p>
                <p>
                  United States organizations
                  <ul>
                    <li><a href="http://www.scamawareness.org/" target="_blank">ScamAwareness.org</a></li>
                    <li><a href="http://www.ftc.gov/" target="_blank">Federal Trade Commission</a></li>
                    <li><a href="http://www.fraud.org/" target="_blank">National Consumers League's Fraud Center</a></li>
                    <li><a href="https://postalinspectors.uspis.gov/" target="_blank">U.S. Postal Inspection Service</a></li>
                    <li><a href="http://www.stopfraud.gov/about.html" target="_blank">StopFraud.gov</a></li>
                    <li><a href="http://www.consumerfinance.gov/" target="_blank">Consumer Financial Protection Bureau</a></li>
                  </ul>
                </p>

              </div>
            </div> 
          }
        </div>
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./js/fraudAwareContent/knowledge.js